import i18n from "config/i18next";

i18n.addResources("es", "templates", {
  newTemplate: "Crear plantilla",
  singleErrorTitle: "Ya existe una plantilla en ese rango",
  singleErrorMessage:
    "Por favor, verificá el siguiente solapamiento e intentá nuevamente",
  multipleErrorsTitle: "Ya existen plantillas en ese rango",
  multipleErrorsMessage:
    "Por favor, verificá los siguientes solapamientos e intentá nuevamente",
});
